<template>
  <div class="st-recommendations">
    <v-toolbar
      card
      dense
      color="grey darken-4"
      class="py-0"
    >
      <v-form
        class="st-recommendations__search"
        @submit.stop.prevent="findProvider"
      >
        <v-layout row>
          <v-flex xs12>
            <v-text-field
              ref="search"
              v-model="searchValue"
              :append-icon="searchValue.length ? 'close' : null"
              :loading="isLoading"
              label="search for your provider..."
              single-line
              autofocus
              color="white"
              hide-details
              @click:append="searchValue = ''"
            />
          </v-flex>
          <v-flex>
            <v-btn
              :disabled="isLoading || !searchValue"
              flat
              dark
              small
              icon
              class="mx-0"
              @click="findProvider"
            >
              <v-icon>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-toolbar>
    <v-card-text>
      <component
        :is="currentView"
        :search-term="searchTerm"
        :service-type="serviceType"
        :popular-providers="popularProviders"
        :search-results="searchResults"
      />
    </v-card-text>
    <v-card-actions v-if="!!serviceType">
      <v-btn
        flat
        small
        @click.prevent="createNonListing"
      >
        <v-icon small class="mr-1">remove_circle</v-icon>
        I don't have this service
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  import axios from 'axios'
  import PopularProviders from './PopularProviders'
  import ProviderSearchResults from './ProviderSearchResults'

  export default {
    data () {
      return {
        currentView: PopularProviders,
        searchValue: '',
        searchTerm: '',
        searchResults: null,
        isLoading: false
      }
    },
    props: ['popularProviders', 'serviceType', 'isActive'],
    computed: {
      showResults () {
        return Array.isArray(this.searchResults)
      }
    },
    watch: {
      isActive (active) {
        if (!active) {
          this.searchValue = ''
        }
      },
      searchValue (value) {
        if (!value) {
          this.clearSearch()
        }
      }
    },
    methods: {
      clearSearch () {
        this.searchTerm = ''
        this.searchResults = null
        this.currentView = PopularProviders
        this.$refs.search.focus()
      },
      findProvider () {
        this.searchTerm = this.searchValue
        this.isLoading = true
        return axios
          .get('/list/providers', {
            params: {
              query: this.searchTerm,
              per_page: 8,
              max_count: 8
            }
          })
          .then((response) => {
            this.isLoading = false
            this.searchResults = response.data
            this.currentView = ProviderSearchResults
          })
          // TODO webpack (mikew): Add fail state for request
      },
      createNonListing () {
        this.$store.dispatch('user/authenticate', {
          action: 'recommendations/setPendingNonListing',
          payload: this.serviceType
        })
      }
    }
  }
</script>

<style lang="stylus">
  .st-recommendations
    &__search
      width: 100%
</style>



// WEBPACK FOOTER //
// frontend/src/components/recommendations/ServiceTypeRecommendations.vue